/**
 * InvestorSidebar - Sidebar do painel de investidores
 *
 * Refatorado para usar BaseSidebar compartilhado
 */

import React from 'react';
import {
  BarChart3,
  Building2,
  Home,
  PieChart,
  HelpCircle,
  Gift,
  Wallet,
} from 'lucide-react';
import { BaseSidebar, NavigationItem } from './BaseSidebar';

interface InvestorSidebarProps {
  onSidebarToggle?: (open: boolean) => void;
}

export const InvestorSidebar: React.FC<InvestorSidebarProps> = ({ onSidebarToggle }) => {
  const navigationItems: NavigationItem[] = [
    {
      label: 'Início',
      href: '/investor/inicio',
      icon: <Home className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Dashboard',
      href: '/investor/dashboard',
      icon: <BarChart3 className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Minha Carteira',
      href: '/investor/my-investments',
      icon: <PieChart className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Produtos Gerais',
      href: '/products',
      icon: <Building2 className="text-sidebar-foreground size-4 shrink-0" />,
    },
    // TEMP: item Beneficios desativado — reativar junto com a rota em App.tsx
    // {
    //   label: 'Benefícios',
    //   href: '/investor/beneficios',
    //   icon: <Gift className="text-sidebar-foreground size-4 shrink-0" />,
    // },
    {
      label: 'Carteira',
      href: '/investor/carteira',
      icon: <Wallet className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Suporte',
      href: '/investor/suporte',
      icon: <HelpCircle className="text-sidebar-foreground size-4 shrink-0" />,
    },
  ];

  return (
    <BaseSidebar
      navigationItems={navigationItems}
      profilePath="/investor/profile"
      onSidebarToggle={onSidebarToggle}
      bodyGap={6}
    />
  );
};

export default InvestorSidebar;
